import { addNotify } from 'features/notify';
import { getErrorMessage } from 'shared/utils/getErrorMessage';

const actionTypes = {
  ACTION_PROCESSING: 'statistic/ACTION_PROCESSING',
  GET_STATISTIC: 'statistic/GET_STATISTIC',
};

const setActionProcessing = actionProcessing => {
  return async (dispatch, getState, extra) => {
    dispatch({
      type: actionTypes.ACTION_PROCESSING,
      payload: {
        [actionTypes.ACTION_PROCESSING]: { actionProcessing },
      },
    });
  };
};

const getStatistic =
  ({ filters, id, callback }) =>
  async (dispatch, getState, extra) => {
    const { api } = extra;
    const locale = getState().locale.errorStatusMessage;
    const { isAuth } = getState().auth;
    if (!isAuth) return;

    dispatch(setActionProcessing(true));

    const response = await api.statistic.getStatistic({ formData: filters, id });

    if (response.success) {
      dispatch({
        type: actionTypes.GET_STATISTIC,
        payload: {
          [actionTypes.GET_STATISTIC]: {
            statistic: response.data,
          },
        },
      });
    } else {
      const { locale } = getState().locale;
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }

    if (callback) callback(response.success ? response.data : null);
    dispatch(setActionProcessing(false));
  };

export { getStatistic, actionTypes };
